export default {
  pageSizes: [10, 20, 30, 40],
  paginationLayout: "prev, pager, next,total, sizes,jumper",
  usergetUserInfo: {},//用户登录信息
  menuPerms: [],//菜单栏权限
  menuChild: [{}],//菜单内容
  emptytextNull: '暂无数据',
  emptytext: "正在加载",
  OAWaitCount: '',  //oa消息数
  tooltipData: null,  //页面提示语
  userOrgs: [] //用户机构
};



// WEBPACK FOOTER //
// ./src/store/state.js